export default __webpack_public_path__ + "static/text-hero-editor-ee81d4047dfe972231a17f0caa9031c8.png";